import { cva } from 'class-variance-authority';

export const buttonVariants = cva(
  'inline-flex items-center justify-center gap-1.5 rounded-full font-bold transition-all active:scale-95 disabled:pointer-events-none disabled:opacity-40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-400/50',
  {
    variants: {
      variant: {
        primary: 'bg-amber-400 text-zinc-950 hover:bg-amber-300',
        solid: 'bg-foreground text-background hover:opacity-80',
        secondary: 'border border-border text-foreground hover:border-zinc-400',
        ghost:
          'text-muted-foreground hover:bg-zinc-100 hover:text-foreground dark:hover:bg-zinc-800',
        danger:
          'border border-red-300 text-red-600 hover:bg-red-50 dark:border-red-800 dark:text-red-400 dark:hover:bg-red-950/30',
      },
      size: {
        sm: 'px-4 py-1.5 text-sm',
        md: 'px-5 py-2.5 text-sm',
        lg: 'px-6 py-3 text-base',
      },
    },
    defaultVariants: { variant: 'primary', size: 'md' },
  },
);
